import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedResources } from '@hooks/mocks/resources'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IAssignees {
  code: string
  description: string
  id: number
  isActive: boolean
}

interface IResources {
  assigneeIds: number[]
  assignees: IAssignees[]
  code: string
  description: string
  id: number
  isActive: boolean
  supervisorId: number
}

export const useFindSiteResources = () => {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  const fetchSiteResources = async () => {
    if (!isMockEnvironment) {
      const url = `sites/${siteId}/resources`
      const { data } = await api.get<IResources[]>(url)
      return data
    }
    return mockedResources
  }
  return useQuery({ queryKey: ['RESOURCES'], queryFn: fetchSiteResources })
}
